"use client"

import { Button } from "@/components/ui/button"

type NotificationType = "all" | "success" | "warning" | "info" | "system"

interface NotificationsFilterProps {
  activeFilter: NotificationType
  onFilterChange: (filter: NotificationType) => void
}

export function NotificationsFilter({ activeFilter, onFilterChange }: NotificationsFilterProps) {
  const filters: { label: string; value: NotificationType }[] = [
    { label: "All", value: "all" },
    { label: "Success", value: "success" },
    { label: "Warnings", value: "warning" },
    { label: "Info", value: "info" },
    { label: "System", value: "system" },
  ]

  return (
    <div className="flex gap-2 flex-wrap">
      {filters.map((filter) => (
        <Button
          key={filter.value}
          onClick={() => onFilterChange(filter.value)}
          variant={activeFilter === filter.value ? "default" : "outline"}
          size="sm"
          className={
            activeFilter === filter.value
              ? "bg-blue-600 text-white hover:bg-blue-700"
              : "border-gray-200 text-gray-700 hover:bg-gray-50"
          }
        >
          {filter.label}
        </Button>
      ))}
    </div>
  )
}
